import React from 'react';
import { Container, Grid } from 'semantic-ui-react';

import EventFeed from '../event-feed';

const containerStyle = {
  paddingTop: 50,
};

export default function Sandbox() {
  return (
    <Container style={containerStyle}>
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <EventFeed
              campaignId="ebf9702f-626b-439b-9676-160cbdfd2ee5"
              feedType="CAMPAIGN"
              viewMode="TABLE"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
}



/** WEBPACK FOOTER **
 ** ./src/containers/sandbox/index.js
 **/